<template>
  <toolbar-container>
    <template #toolbar>
      <reports-toolbar class="gl-toolbar" />
    </template>

    <v-row class="pa-3 ma-0">
      <v-col
        v-if="!isAccurate"
        class="pa-0 ma-0 mb-3"
        cols="12"
      >
        <v-alert
          class="mb-0"
          dense
          :prominent="$vuetify.breakpoint.smAndUp"
          border="left"
          type="info"
          xcolor="primary"
        >
          <v-row align="center">
            <v-col class="pb-0 pa-sm-3">
              {{ $t('message.report_align_to_weeks') }}
            </v-col>
            <v-col class="pt-1 pa-sm-3 col-12 col-sm-auto">
              <v-btn
                color="white"
                outlined
                :small="$vuetify.breakpoint.xsOnly"
                block
                @click="makeAccurate"
              >
                {{ $t('button.report_align_weeks') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-alert>
      </v-col>
      <v-col
        cols="12"
        class="pa-0 ma-0 pb-3"
      >
        <avg-guests-weekday-chart
          :category="averageGuests.category"
          :dataset="averageGuests.dataset"
        />
      </v-col>
    </v-row>
    <v-row class="pa-0 ma-0">
      <v-col
        cols="12"
        md="6"
        class="pa-0 ma-0 pr-md-3 pb-3 pb-md-0"
      >
        <weekdays-bar-chart
          :title="$t('label.report_services_and_revenue')"
          :series="services.series"
          :dataset="services.dataset"
          :series-revenue="servicesRevenue.series"
          :dataset-revenue="servicesRevenue.dataset"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
        class="pa-0 ma-0"
      >
        <weekdays-bar-chart
          :title="$t('label.report_guests_per_section')"
          :series="tabs.series"
          :dataset="tabs.dataset"
        />
      </v-col>
    </v-row>
  </toolbar-container>
</template>

<script lang="ts">
import Vue from 'vue';

import ReportsToolbar from '@/components/views/reports/ReportsToolbar.vue';
import WeekdaysBarChart from '@/components/views/reports/WeekdaysBarChart.vue';
import AvgGuestsWeekdayChart from '@/components/views/reports/AvgGuestsWeekdayChart.vue';
import { ChartData, reportsValidateDateRange } from '@/services/reports-utils';
import { loadStoreModule, unloadStoreModule } from '@/services/module-loader';
import ReportsStore from '@/store/reports-store';
import { ReportsType } from '@/services/reports';
import {
  DateRange, isWholeWeeks, makeWholeWeeks,
} from '@/services/date-range';
import { performActionEx } from '@/services/vue-utils';

export default Vue.extend({
  name: 'ReportWeekdays',
  components: {
    ReportsToolbar,
    AvgGuestsWeekdayChart,
    WeekdaysBarChart,
  },
  data() {
    return {};
  },
  computed: {
    isAccurate(): boolean {
      const dr = this.$tstore.state.reports.dateRange as DateRange;
      const ndr = makeWholeWeeks(dr, this.$localized.firstDayOfWeek());
      const error = reportsValidateDateRange(ndr);
      return error !== undefined || isWholeWeeks(dr.beginDate, dr.endDate, this.$localized.firstDayOfWeek());
    },
    averageGuests(): { dataset?: [number, number, number][], category?: Date[] } {
      return this.$tstore.getters.reportsWeekdaysAverageGuests;
    },
    services(): ChartData {
      return this.$tstore.getters.reportsWeekdaysServices;
    },
    servicesRevenue(): ChartData {
      return this.$tstore.getters.reportsWeekdaysServicesRevenue;
    },
    tabs(): ChartData {
      return this.$tstore.getters.reportsWeekdaysTabs;
    },
  },
  created() {
    loadStoreModule(this, 'reports', ReportsStore, async () => {
      this.$tstore.dispatch('updateReports', { reportsType: ReportsType.Weekdays });
    });
  },
  beforeDestroy() {
    unloadStoreModule(this, 'reports', async () => { this.$tstore.dispatch('resetReports'); });
  },
  methods: {
    async makeAccurate() {
      const dr = this.$tstore.state.reports.dateRange as DateRange;
      const ndr = makeWholeWeeks(dr, this.$localized.firstDayOfWeek());

      await performActionEx(
        async () => this.$tstore.dispatch('setReportsDateRange', ndr),
        { errorPrefix: this.$i18n.tc('error.load_data'), hideActivityIndicator: true },
      );
    },
  },
});
</script>
